import { exhaustiveGuard } from "@mcwd/typescript-type-guards";
import { tacticIdMapping } from "./tacticIdMapping.js";
import { ExternalReferrerMetaData, type ExternalReferrerMetaDataType } from "../external-referrer-metadata/getExternalReferrerMetaData.js";
import { UtmCampaign } from "../../cookie-persisted-value-getters.js";
import { ComputedValueGetter } from "../../../../utils/ComputedValueGetter.js";


/**
  Calculate the tacticID based on the following values in order of priority:
  #### 1. utm_campaign (not considered in this function.  Call `getTacticId` instead! )
  #### 2. External Referrer
    - Top 5 Search Engine
    - PR Domain
    - Social Media Domain
  #### 3. Referral (Any other domain in ExternalReferrer)
  #### 4. Direct (When ExternalReferrer is empty)
*/
function getTacticIdFromExternalReferrerOnly (extReferrerData?: ExternalReferrerMetaDataType | undefined){
  // document.referrer stored in source_string cookie (30 days)
  extReferrerData ??= ExternalReferrerMetaData.value;
  switch (extReferrerData.type) {
    case "direct": return tacticIdMapping.direct;
    case "top-5-search": return tacticIdMapping.organicSearch;
    case "pr-domain": return tacticIdMapping.pr;
    case "social-media": return tacticIdMapping.social[ extReferrerData.name ];
    case "referral": return tacticIdMapping.referral;
    default: exhaustiveGuard(extReferrerData);
  }
}

/**
  Calculate the tacticID based on the following values in order of priority:
  #### 1. utm_campaign if it exists
  #### 2. External Referrer
    ##### a.) Top 5 Search Engine
    ##### b.) PR Domain
    ##### c.) Social Media Domain
  #### 3. Referral (Any other domain in ExternalReferrer)
  #### 4. Direct (When ExternalReferrer is empty)
*/
export function getTacticId (): string;
export function getTacticId (opts: {
  linkAttributionCampaign?: string | undefined,
  extReferrerData?: ExternalReferrerMetaDataType
}): string;
export function getTacticId ({
  linkAttributionCampaign,
  extReferrerData
}: {
  linkAttributionCampaign?: string | undefined,
  extReferrerData?: ExternalReferrerMetaDataType
} = {}): string
{
  linkAttributionCampaign ??= UtmCampaign.value;
  return linkAttributionCampaign === ""
    ? getTacticIdFromExternalReferrerOnly(extReferrerData)
    : linkAttributionCampaign;
}
export const TacticId = new ComputedValueGetter({
  isLazy: true, 
  computeFn: () => {
    return getTacticId();
  }
});

